import { render, staticRenderFns } from "./ThemeHeader.vue?vue&type=template&id=2684758a"
import script from "./ThemeHeader.vue?vue&type=script&lang=js"
export * from "./ThemeHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports